import React, { useState } from "react";
import { BRAND } from "../config/brand";
import { useAuth, apiErr } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Giriş başarılı");
    } catch (ex) {
      const msg = apiErr(ex.response?.data?.detail) || "Giriş başarısız";
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden bg-navy-900">
        <div className="absolute inset-0 opacity-25"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1708457753320-02e52a276a80')", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-navy-900/80" />
        <div className="relative z-10">
          <div className="inline-flex items-center justify-center bg-white rounded-2xl p-5 shadow-lg">
            <img src={BRAND.logos.symbol} alt={BRAND.name} className="h-24 w-24 object-contain" />
          </div>
        </div>
        <div className="relative z-10">
          <h1 className="font-heading text-4xl font-bold text-white leading-tight">{BRAND.name}</h1>
          <p className="mt-3 text-slate-300 text-lg">{BRAND.subBrand}</p>
          <p className="mt-4 text-slate-400 text-sm tracking-wide">Masraf Avansı · Vekâlet Ücreti · Tahsilat</p>
        </div>
        <div className="relative z-10 text-xs text-slate-500">© {new Date().getFullYear()} {BRAND.subBrand}</div>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 bg-background">
        <div className="w-full max-w-sm animate-in-up">
          <div className="lg:hidden flex flex-col items-center mb-8">
            <div className="bg-white rounded-2xl p-4 shadow-sm border border-slate-200">
              <img src={BRAND.logos.symbol} alt={BRAND.name} className="h-24 w-24 object-contain" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-navy-900 mt-4">{BRAND.name}</h1>
            <p className="text-slate-400 text-sm">{BRAND.subBrand}</p>
            <p className="text-slate-400 text-xs mt-1 tracking-wide">Masraf Avansı · Vekâlet Ücreti · Tahsilat</p>
          </div>
          <h2 className="font-heading text-2xl font-bold text-navy-900">Giriş Yap</h2>
          <p className="text-slate-500 text-sm mt-1 mb-6">Hesabınıza erişmek için bilgilerinizi girin.</p>

          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">E-posta</Label>
              <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@saglamhukuk.com" className="h-12 rounded-xl" required />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Şifre</Label>
              <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" className="h-12 rounded-xl" required />
            </div>
            {err && <p data-testid="login-error" className="text-sm text-brand-red bg-brand-redbg rounded-lg px-3 py-2">{err}</p>}
            <Button data-testid="login-submit-btn" type="submit" disabled={busy}
              className="w-full h-12 rounded-xl bg-navy-900 hover:bg-navy-800 text-white font-medium active:scale-[0.98] transition-transform">
              {busy ? "Giriş yapılıyor…" : "Giriş Yap"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
